import axios from "axios";
import { API_BASE_URL } from "../constants/api-url";

const restClient = axios.create({
    baseURL: API_BASE_URL,
});

export default restClient;